import { Button, ConfigContext, Form, Input } from "@pionex-web-kit/components";
import React, { useCallback, useContext } from "react";
import { useTranslators } from "../hooks/Locale";
import { isEmail } from "../utils/utils";
import { ZendeskWidget } from "../ZendeskWidget";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var InputContact = function InputContact(_ref) {
  var close = _ref.close;
  var _useTranslators = useTranslators(),
    $st = _useTranslators.$st;
  var _useContext = useContext(ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls("helpCenter-ic");
  var onFinish = useCallback(function (values) {
    close();
    ZendeskWidget.setContact(values.contact);
    ZendeskWidget.open();
  }, []);
  var validator = useCallback(function (_, value) {
    if (!isEmail(value)) {
      return Promise.reject(new Error($st("invalid_username_toast_email")));
    }
    return Promise.resolve();
  }, []);
  return /*#__PURE__*/_jsx(Form, {
    onFinish: onFinish,
    className: prefixCls,
    children: /*#__PURE__*/_jsxs("div", {
      className: "".concat(prefixCls, "-form-wrap"),
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: "".concat(prefixCls, "-desc"),
          children: $st("zendesk_visitor_input_contact")
        }), /*#__PURE__*/_jsx(Form.Item, {
          name: "contact",
          rules: [{
            validator: validator
          }],
          children: /*#__PURE__*/_jsx(Input, {
            label: $st("zendesk_visitor_place_holder_contact"),
            size: "large"
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          size: "large",
          htmlType: "submit",
          className: "".concat(prefixCls, "-submit"),
          children: $st("button_ok")
        })
      })]
    })
  });
};